import { usePage } from "@inertiajs/react"
import type { SharedProps } from "@/types"

/**
 * Токен для не-Inertia fetch (PATCH/POST) в компонентах.
 *
 * Предпочтительно брать из shared `csrf_token` (обновляется на каждом Inertia-ответе).
 * Для модулей lib/*-api.ts используй `getCsrfToken()` — он читает cookie `XSRF-TOKEN`
 * (Inertia Rails обновляет его после login/`reset_session`), затем meta.
 */
export function useCsrfToken(): string {
  const { csrf_token } = usePage<SharedProps>().props
  if (csrf_token) return csrf_token
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
}
